import React from 'react';
import Container from 'react-bootstrap/Container';
import Nav from 'react-bootstrap/Nav';
import Navbar from 'react-bootstrap/Navbar';
import logoUrl from '../assets/img/logoEvo7.svg';
import sloganUrl from '../assets/img/slogan.png';
import './Header.css'; 
import {ABOUT_ROUTE, CONTACTS_ROUTE, PAY_AND_SHIP_ROUTE, REFUND_ROUTE, WARRANTY_ROUTE} from "../utils/const";



function Header() {

  return (
    <div className="bg-dark py-2 py-xxl-0">
         <Container className="d-flex justify-content-between align-items-center">
            <div className="mt-2 mb-3">
              <a href="/" alt="Интернет-магазин ЭВОСЕМЬ"><img className="logo" src = {logoUrl} alt="logo"></img></a>
            </div>
            <div>
              <img className="slogan d-none d-xxl-block" src = {sloganUrl} alt="slogan"></img>
            </div>
            <Navbar bg="dark" className=" d-none d-lg-block" data-bs-theme="dark">
               <Nav className="me-auto">
                 <Nav.Link href={ABOUT_ROUTE}>О компании</Nav.Link>
                 <Nav.Link href={PAY_AND_SHIP_ROUTE}>Оплата и доставка</Nav.Link>
                 <Nav.Link href={WARRANTY_ROUTE}>Гарантия</Nav.Link>
                 <Nav.Link href={REFUND_ROUTE}>Возврат</Nav.Link>
                 <Nav.Link href={CONTACTS_ROUTE}>Контакты</Nav.Link>
               </Nav>
            </Navbar>
            <div className="phone d-none d-sm-block" bg="dark" data-bs-theme="dark">
              <a className="pnmb" href="tel:+79375552585">8 937 555-25-85</a><br/>
              <a className="callback-link" href="#">Заказать обратный звонок</a>
            </div>
          </Container>
          </div>
  );
}

export default Header;